import React from 'react';
import OdxTable from "../../../../OdxComponents/NativeOdx/Table/Odx-Table";
import {OdxTableRow} from "../../../../OdxComponents/NativeOdx/Table/Odx-TableRow";
import {OdxTableCell} from "../../../../OdxComponents/NativeOdx/Table/Odx-Tablecell";
import {odxVariants} from "../../../../OdxComponents/constants";
import OdxChip from "../../../../OdxComponents/NativeOdx/Odx-Chip";
import {removeDuplicates} from "../../../../Utils/transformer";
import {KafkaEvent} from "../../Interfaces/IKafkaEvents";

interface LogsTableProps {
    eventList: KafkaEvent[];
    searchTerm: string;
    sourceFilter: string; // when filtering using the SourceTree on the left!
}

const formatTableCell = (key: string, event: KafkaEvent): React.ReactNode => {
    switch (key) {
        case 'Time':
            return new Date(event[key]).toLocaleString();
        case 'LogLevel':
            let variant;
            const logLevel = event[key];
            if (logLevel == "Error") variant = odxVariants.danger;
            else if (logLevel == "Warning") variant = odxVariants.warning;
            else if (logLevel == "Info") variant = odxVariants.secondary;
            else throw new Error("invalid logLevel: " + logLevel);
            return <OdxChip size={"small"} content={event[key]} variant={variant}/>;
        default:
            return event[key];
    }
};

const LogsTable: React.FC<LogsTableProps> = ({eventList, searchTerm, sourceFilter}) => {
    const allEvents: KafkaEvent[] = eventList;

    // table headers are simple the property-names of the events. we want to display all properties, so we just use all keys from all eventLog-objects
    const tableHeaders = removeDuplicates(allEvents.map(x => Object.keys(x)).flat());

    const hiddenColumns = ["Id", "PartitionKey", "RowKey", "odata.etag", "damsEventId", "Timestamp"];

    const columns = tableHeaders
        .filter((column) => !hiddenColumns.includes(column))
        .map((head) => ({
            name: head,
            title: head.replace("Detail_", ""),
            sortable: true
        }));

    if (allEvents.length) // will crash if we have no events and this no columns/headers
    {
        // change the order to put important properties first (left)
        const importantHeaders = ["Source", "Type", "Time", "LogLevel"];
        importantHeaders.forEach(header => columns.unshift(columns.splice(columns.findIndex(obj => obj.name === header), 1)[0]));
    }

    const filteredEvents = allEvents.filter((event) => {
        if (searchTerm) {
            const lowerSearchTerm = searchTerm.toLowerCase();
            const columnValues = columns.map(col => event[col.name]).filter(x => x != null).map(x => x.toString().toLowerCase());
            if (columnValues.every(x => !x.includes(lowerSearchTerm))) return false;
        }

        if (sourceFilter)
        {
            // check if the sourceFilter is part of the event's source
            if(!event.Source.toLowerCase().includes(sourceFilter.toLowerCase())) return false;
        }

        return true;
    });

    const tableRows = filteredEvents.map((event, index) => (
        <OdxTableRow key={index}>
            {columns.map((column, idx) => (
                <OdxTableCell key={idx} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {formatTableCell(column.name, event)}
                </OdxTableCell>
            ))}
        </OdxTableRow>
    ));

    const Style: React.CSSProperties = {
        height: 'calc(100vh - 450px)',
        minHeight: '400px',
    }

    return (
        <div className="w-full " style={Style}>
            <OdxTable
                headerData={columns}
                ariaDescribedby="tableOfUsers"
                id={"DamsLogs"}
                className="w-full h-full"
                variant="striped"
                paginated={true}
                itemsPerPage={100}
                tableHeight="100%"
            >
                {tableRows}
            </OdxTable>
        </div>
    );
};

export default LogsTable;
